import { composeIO } from 'react-compose-io'
import { historicoDebitoIO } from './HistoricoDebito.IO'
import { HistoricoDebitoView } from './HistoricoDebito.View'

export const HistoricoDebito = composeIO(HistoricoDebitoView, historicoDebitoIO)
